export const ACCOUNT_LEDGER_ORIGINAL_SOURCE = {
  PREPAYMENT: "Prepayment",
  ADJUSTMENT: "Adjustment",
  DELIVERY_COLLECTION:"DeliveryCollection",
  COD_TRANSFER:"CODTransfer",
  COC_COLLECTION:"CocCollection",
  // WITHDRAWAL: "Withdrawal",
  // TRANSFER: "Transfer",
  // DEPOSIT: "Deposit",
};
